export const editorApiKey = 'z9o2fk2vqhq3k9ir26ckmi3hq9r0x1sl4s37xqokdc63n2mp';

//  images

export const striveLogo = 'strive-logo.png';
export const striveWhiteLogo = 'strive-white.svg';
export const hscLogo = '6d823d0218585dbb63883414c840e9d84078390ccb7c34d5e586c7b3e96bb4a2f866d2e2a883b7b7e29ede656cea5f92511a09e5d598b12f2833451ac81f6095_hsc-logo.jpeg';
export const videoImage = 'training/c311e4fc868d99a0f5309ae29b62226a0649502fcff35d1b6b120cfc62dc15de522e02467ab03e5cd71ef73defd0ac12b771356e6d50c189de99246cb8d559ca_video.png';

export const startYear = 2019;